module.exports = __webpack_public_path__ + "media/images/icons/trustpilot-star-inverted-half-filled-c8c8b7aabd8566d97b292b5c0822efa6.svg";